class MyProfileController {
  constructor (UserService, I18n) {
    'ngInject'
    this.I18n = I18n
    this.userService = UserService
    this.isProcessing = true
    this.loaded = this.init()
  }

  init () {
    return this.userService.getCurrentUser()
    .then((user) => {
      this.user = user
      this.isProcessing = false
    })
  }

}

export default MyProfileController



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/my-profile.controller.js